function createHttpError(message, status) {
  const error = new Error(message);

  error.status = status;
  return error;
}

async function parseError(response, fallbackMessage) {
  try {
    const json = await response.json();
    const message = json?.message;

    if (typeof message === 'string' && message.trim()) {
      return createHttpError(message, response.status);
    }
  } catch {}

  return createHttpError(fallbackMessage, response.status);
}

export function createListingsService({
  apiBaseUrl,
  fetchFn = globalThis.fetch,
} = {}) {
  if (!apiBaseUrl) {
    throw new Error('An API base URL is required.');
  }

  if (typeof fetchFn !== 'function') {
    throw new Error('A fetch implementation is required.');
  }

  return {
    async getListingDetail(slug, { session } = {}) {
      const headers = {};

      if (session?.sessionToken) {
        headers.authorization = `Bearer ${session.sessionToken}`;
      }

      const response = await fetchFn(`${apiBaseUrl}/listings/${encodeURIComponent(slug)}`, {
        headers,
        method: 'GET',
      });

      if (!response.ok) {
        throw await parseError(response, 'Impossible de charger cette annonce.');
      }

      return response.json();
    },

    async listBrowseFeed({ countryCode } = {}) {
      const feedUrl = countryCode
        ? `${apiBaseUrl}/listings?countryCode=${encodeURIComponent(countryCode)}`
        : `${apiBaseUrl}/listings`;
      const response = await fetchFn(feedUrl, {
        method: 'GET',
      });

      if (!response.ok) {
        throw await parseError(response, 'Impossible de charger les annonces.');
      }

      const data = await response.json();
      return { ...data, items: data.items.map(item => ({ ...item, thumbnailUrl: item.thumbnailPath ? `${apiBaseUrl}${item.thumbnailPath}` : null })) };
    },

    async reportSearchQuery(payload) {
      try {
        await fetchFn(`${apiBaseUrl}/market-signals/search`, {
          body: JSON.stringify(payload),
          headers: {
            'content-type': 'application/json',
          },
          method: 'POST',
        });
      } catch {}
    },
  };
}
